var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_vm._m(0),_c('p',{staticClass:"h3"},[_vm._v(_vm._s(_vm.translate("could-not-find-any"))+" "+_vm._s(_vm.type))]),_c('p',{staticClass:"h6"},[_vm._v(_vm._s(_vm.translate("add-new"))+" "+_vm._s(_vm.type))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"display-1"},[_c('span',{staticClass:"fas fa-search fa-sm"})])
}]

export { render, staticRenderFns }